import { LoadingButton, LoadingButtonProps } from '@mui/lab';
import { SxProps, Theme } from '@mui/material';

interface PrimaryButtonProps extends Omit<LoadingButtonProps, 'sx'> {
  sx?: SxProps<Theme>;
}

export function PrimaryButton({ children, sx, ...props }: PrimaryButtonProps) {
  return (
    <LoadingButton
      variant="contained"
      sx={{
        padding: '8px 16px',
        backgroundColor: '#AF52DE',
        borderRadius: '6px',
        color: '#ffffff',
        fontSize: '16px',
        fontFamily: 'Inter',
        fontWeight: 400,
        lineHeight: '28px',
        letterSpacing: '-0.176px',
        textTransform: 'none',
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        '&:hover': {
          backgroundColor: '#9A3EC5',
        },
        '&.Mui-disabled': {
          backgroundColor: (theme) => theme.palette.action.disabledBackground,
          color: (theme) => theme.palette.action.disabled,
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </LoadingButton>
  );
}
